import styled from 'styled-components';
import {
  border,
  borderRadius,
  BorderRadiusProps,
  GridProps,
  gridRowGap,
  padding,
  PaddingProps,
  variant,
} from 'styled-system';
import ThemeUtilities from '../../../theme/ThemeUtilities';
import { SubscriptionComponentCardVariants } from './types';

export const CardWrapper = styled.div<
  PaddingProps &
    BorderRadiusProps &
    GridProps & { variant: SubscriptionComponentCardVariants }
>`
  display: flex;
  flex-direction: column;
  ${borderRadius};
  ${border};
  ${padding};
  ${gridRowGap};
  ${(props) =>
    variant(
      ThemeUtilities.getComponentVariant(
        props,
        'SubscriptionComponentCard',
        'variant'
      )
    )};
`;
